import React from 'react';

import ErrorPage from '../../Error/Error';

const API_HOST = process.env.API_HOST || '';

export class ErrorBoundary extends React.Component {
    state = {
        error: false,
        errorMessage: null,
    };

    componentDidCatch(error, info) {
        const errorMessage = `${error ? error.toString() : 'React did not provide an error object.'}`;
        const stack = info ? info.componentStack : 'Stack unavailable';

        this.setState({
            error: true,
            errorMessage: `${errorMessage}\n${stack}`,
        });

        if (typeof window !== 'undefined') {
            const errorsForUpload = JSON.stringify([{
                msg: errorMessage,
                file: 'patient-web-app.js',
                line: 0,
                stack,
            }]);

            const body = `errors=${encodeURIComponent(errorsForUpload)}&page=${encodeURIComponent(window.location.href)}&datadogLogName=patient_web_app.jserrors`;

            fetch(`${API_HOST}/remote/javascripterror/`, {
                method: 'POST',
                headers: { 'content-type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                body,
            });
        }
    }

    render() {
        if (this.state.error) {
            return (
                <ErrorPage
                    errorCode={500}
                    errorMessage={this.state.errorMessage}
                />
            );
        }

        return this.props.children;
    }
}
